<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title"><span class="bold">Contents</span></h1>
<h2 class="tocf"><a href="#/xhtml/04_Acknowledgements">Acknowledgements</a></h2>
<h2 class="tocf"><a href="#/xhtml/05_Introduction">Introduction</a></h2>
<h2 class="toc"><a href="#/xhtml/06_Chapter01"><span class="toc">Chapter 1</span> Ian Brady – The Early Years</a></h2>
<h2 class="toc"><a href="#/xhtml/07_Chapter02"><span class="toc">Chapter 2</span> Myra Hindley – The Early Years</a></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter03" title="Link target outside of Sample"><span class="toc">Chapter 3</span> Hindley Meets Brady</span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter04" title="Link target outside of Sample"><span class="toc">Chapter 4</span> The Twisted World of Brady &amp; Hindley</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter05" title="Link target outside of Sample"><span class="toc">Chapter 5</span> David Smith</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter06" title="Link target outside of Sample"><span class="toc">Chapter 6</span> Reconnaissance &amp; Pauline Reade</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter07" title="Link target outside of Sample"><span class="toc">Chapter 7</span> A Near Miss &amp; John Kilbride</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter08" title="Link target outside of Sample"><span class="toc">Chapter 8</span> Keith Bennett</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter09" title="Link target outside of Sample"><span class="toc">Chapter 9</span> Wardle Brook Avenue</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter10" title="Link target outside of Sample"><span class="toc">Chapter 10</span> Lesley Ann Downey</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter11" title="Link target outside of Sample"><span class="toc">Chapter 11</span> Drunken Evenings &amp; Missed Opportunities</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter12" title="Link target outside of Sample"><span class="toc">Chapter 12</span> Edward Evans</span></h2>
<h2 class="toc"><span href="#/xhtml/18_Chapter13" title="Link target outside of Sample"><span class="toc">Chapter 13</span> Arrest</span></h2>
<h2 class="toc"><span href="#/xhtml/19_Chapter14" title="Link target outside of Sample"><span class="toc">Chapter 14</span> Evidence</span></h2>
<h2 class="toc"><span href="#/xhtml/20_Chapter15" title="Link target outside of Sample"><span class="toc">Chapter 15</span> The Committal</span></h2>
<h2 class="tocf"><span href="#/xhtml/21_Epilogue" title="Link target outside of Sample">Epilogue</span></h2>
<h2 class="tocf"><span href="#/xhtml/22_Bibliography" title="Link target outside of Sample">Bibliography</span></h2>
<h2 class="tocf"><span href="#/xhtml/23_Part02" title="Link target outside of Sample">Coming in Part 2 – ‘Convicting The Moors Murderers’</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?7da4ec1e